import React, { Component } from 'react';
import {Toolbar} from 'primereact/components/toolbar/Toolbar';
import {Button} from 'primereact/components/button/Button';
import {PRICE_URL,PRICE_URL_PROD} from '../constants'; 

class AiToolbar extends Component {
    constructor(props) {
        ////console.log('toolbar constr') 
         super(props);
     
         this.state = {
           price: "0",
           last_clist:'',
           last_chain:''
         };
         this.componentDidUpdate()
       }
 
       componentDidUpdate() {
        let fetchUrl =PRICE_URL
        if (window.currentEnv ==='www'){
            fetchUrl =PRICE_URL_PROD
        }
   //     fetchUrl ='http://52.21.230.12/charmprice/'
        let header = new Headers({
                  'Access-Control-Allow-Origin': '*',
                  'Content-Type': 'multipart/form-data'
              });
        let sentData = {
          method: 'GET', //opt.method,
          mode: 'cors',
          header: header,
        };
        if (this.props.charms && (this.state.last_clist !== this.props.clist ||this.state.last_chainsku !== this.props.chainsku)){
        fetch(fetchUrl + '?clist=' + this.props.clist +'&store='+this.props.store +'&chain='+this.props.chainsku,sentData)
        .then(response => {
            if (response.ok) {
            
                return response.json();
            }
            else {
          //      this.state={error: true}
                this.messages.show({
                    severity: 'error',
                    sticky: true,
                    summary: 'Error loading item info: ',
                    detail: 'Cannot load data'
                });
                throw new Error('Something went wrong ...');
            }
        })
        .then(json => {
          if (Object.keys(json).length === 0) {
            //    this.state={error: true}
                this.messages.show({
                    severity: 'error',
                    sticky: true,
                    summary: 'Error loading item info: ',
                    detail: 'No load data'
                });
                throw new Error('Something went wrong ...');
                  }
                  //this.setState ({ price: json['p']})
                 if (this.state.price !== json['p'])
                 {
                      //this.state.price = json['p']
                      this.setState ({ price: json['p']})
                      //this.props.onRefreshPrice('totalprice',json) //['refresh_parent'])
                    }
                if (this.state.last_clist !== this.props.clist)
                    {
                         //this.state.last_clist = this.props.clist
                         this.setState ({ last_clist: this.props.clist})
                         this.props.onRefreshPrice(json) //['refresh_parent'])
                       }
                if (this.state.last_chainsku !== this.props.chainsku)
                       {
                            //this.state.last_clist = this.props.clist
                            this.setState ({ last_chainsku: this.props.chainsku})
                            this.props.onRefreshPrice(json) //['refresh_parent'])
                          }
      
               //          this.state[ 'lastSku']= this.props.sku 
                // if (this.props.price !== json['p']){   
                 // this.props.onRefreshReview('title',json.refresh_parent.title) //['refresh_parent'])
                 //console.log('json.price3', json['p'])
                 //}
          })
        }   
    


       }
       
    render() {
        //console.log('render ADD Button',this.props.readyForAddToCart , this.props.readyForSession)
        let cartText="Add to Shopping Bag" 
        let bcolor ='ai-bcolor-' + window.currentSite
     //   console.log('ren',this.props.size)
        if (this.props.optionNumber === 2 ||this.props.optionNumber === 3) {
            cartText = "Add to Bag" 
        }
        let AddButton=''
        if (this.props.save_qsku) {
            if (this.props.active_image_url == undefined)
                AddButton = <Button className={bcolor}  label="Update Qsku" disabled/>
            else
                AddButton = <Button className={bcolor}  label="Update Qsku" onClick={() => this.props.onUpdateQsku(this.props.active_image_url.split('?')[1]+'&style='+this.props.style)}/>
  
            } else if (this.props.readyForAddToCart && this.props.readyForSession){

            var allparam= this.props.urlParams
            if (window.vto_click  !== undefined)
               allparam['vto'] = window.vto_click
            else
               allparam['vto'] = '?'
            if (window.vto_add_to_cart  !== undefined)
               allparam['vto'] +='-'+ window.vto_add_to_cart
            else
               allparam['vto'] += '-?'
         //   console.log('vto', allparam['vto'])   
            AddButton = <Button className={bcolor} label={cartText}  onClick={() => this.props.onAddToCart(allparam)}/>
        } else if (this.props.readyForSession === false) {
            AddButton = <Button className={bcolor}  label={cartText} onClick={this.props.onNoSessionMessage}/>
        } else if (this.props.readyForAddToCart === false) {
            AddButton = <Button className={bcolor}  label={cartText} onClick={this.props.onNoOptionMessage}/>

        }
    









        let charms=''
        let charmsText='Review / Remove'
        if (this.props.optionNumber === 2 ||this.props.optionNumber === 3) {
            charmsText='Review'
        }
        if (this.props.charms && (this.props.clistqty !== 0 || ( this.props.chainmetal !== 'no'&& this.props.chainmetal !== '-1' ))) {
       /*     if (this.props.size !== 'small'){
                if (this.props.clistqty === 1)
                    charmsText='Review: 1 charm'
                else    
                    charmsText='Review: '+ String(this.props.clistqty) +' charms'
            }*/
 //           if (this.props.charmreview)
 //               charms = <Button className={bcolor}  label='Close Review' onClick={this.props.onHideCharm}/>
 //           else
            charms = <Button className={bcolor}  label={charmsText} onClick={this.props.onShowCharm}/>
       }
        
     
      // console.log("ADD TO CART Price",this.props.price,this.props.charms)
       let color ='ai-toolbar-price ai-color-' + window.currentSite
       var price1 = ''
       
       if (this.props.charms)
        price1 = this.state.price === null ? '' : ('$' + this.state.price)
       else
        price1='$'+this.props.price
       //promo
     /*  if (['kay','kayoutlet'].indexOf(window.currentSite) !== -1) {
          price1 ='$'+(this.props.price * 0.95).toFixed(2).toString() + " (5% discount applied)"
       }*/
        return (<div className="ai-toolbar-group">
        <Toolbar>
        
    <div className="ui-toolbar-group-left">
    <div className={color}>
    {price1}
    </div>
    </div>
    <div className="ui-toolbar-group-left">
    {charms}
    </div>
     
    <div className="ui-toolbar-group-right">
        {AddButton}
    </div>
    
</Toolbar>

      </div>
        );
    }
}

export default AiToolbar;


// WEBPACK FOOTER //
// ./src/layout/AiToolbar.js